import React, { useState } from 'react';
import styles from './styles/styles.module.css';
import { useLocation, useNavigate } from 'react-router-dom';
import breadCrumbProcessor from '../Sidebar/lib/breadCrumbProcessor';
import { useDispatch, useSelector } from 'react-redux';
import { setCurrentSite } from '../../Redux/slices/currentSiteSlice';
import { changeSelectedSite } from '../../api/user/post';
import { FaPowerOff } from 'react-icons/fa';
import { signOut } from '@aws-amplify/auth';
import { setAuthenticated } from '../../Redux/slices/authSlice';

const Header: React.FC<any> = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { sites } = useSelector((state: any) => state.associatedSites);
  const { siteName } = useSelector((state: any) => state.currentSite);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { assignedSites, userType } = useSelector((state: any) => state.user);

  function filteredSites(): any[] {
    if (userType === 'HYPER_ADMIN' || userType !== 'COMPANY_ADMIN') {
      return sites.filter((site: any) => assignedSites.includes(site._id));
    } else {
      return sites;
    }
  }

  async function handleSiteSelect(e: any) {
    setLoading(true);
    try {
      const data = JSON.parse(e.target.value);
      const res = await changeSelectedSite(data._id);

      //updates last selected on backend

      if ((res as any).success) {
        const payload = {
          siteId: data._id,
          siteName: data.siteName,
          timezone: data.timezone,
          shiftStart: data.shiftStartTime,
        };

        dispatch(setCurrentSite(payload));
        window.location.reload();
      } else {
        alert('Something went wrong, please refresh the page and try again');
      }
    } catch (err) {
      alert('Something went wrong, please refresh the page and try again');
    } finally {
      setLoading(false);
    }
  }

  async function handleLogout() {
    try {
      // 1. Sign out from Cognito
      await signOut();

      // 2. Clear LocalStorage
      localStorage.clear();
      sessionStorage.clear();

      // 3. Reset auth state
      dispatch(setAuthenticated(false));

      // 4. Redirect to login page (or refresh)
      window.location.href = '/login';
    } catch (error) {
      console.error('Error during logout:', error);
    }
  }

  return (
    <div className={styles.breadCrumbContainer}>
      <div className={styles.breadcrumbs}>
        <p
          onClick={() =>
            navigate(breadCrumbProcessor(location.pathname)?.routes[0])
          }
          className={styles.breadcrumbItem}
        >
          {breadCrumbProcessor(location.pathname)?.desc[0]}
        </p>
        <p className={styles.breadcrumbItemDark}>
          {location.pathname === '/dashboard' ? null : '/'}
        </p>
        <p className={styles.breadcrumbItemDark}>
          {breadCrumbProcessor(location.pathname)?.desc[1]}
        </p>
      </div>
      <select
        disabled={loading}
        onChange={handleSiteSelect}
        className={styles.siteSelector}
        value={JSON.stringify(sites.find((s: any) => s.siteName === siteName))}
      >
        <option value="" disabled hidden>
          Select site
        </option>
        {filteredSites().length > 0 &&
          filteredSites().map((site: any) => (
            <option key={site._id} value={JSON.stringify(site)}>
              {loading ? 'Please Wait...' : site.siteName}
            </option>
          ))}
      </select>
      <FaPowerOff onClick={handleLogout} className={styles.logoutButton} />
    </div>
  );
};

export default Header;
